module.exports = __webpack_public_path__ + "static/media/node.3e4586a0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/node.svg
// module id = 64
// module chunks = 0